import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AutoCompleteModule, ButtonModule, DataTableModule, DialogModule, InputTextModule, TooltipModule } from 'primeng/primeng';

import { UserListComponent } from './user-list/user-list.component';
import { FilterModule } from 'app/shared/filter/filter.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    AutoCompleteModule,
    ButtonModule,
    DataTableModule,
    DialogModule,
    InputTextModule,
    TooltipModule,
    FilterModule
  ],
  declarations: [
    UserListComponent
  ],
  exports: [
    UserListComponent
  ]
})
export class UserSharedModule { }



// WEBPACK FOOTER //
// /dist/src/app/user/user-shared/user-shared.module.ts